import React, { Component } from 'react';
import PopUp from './functions/popup.js';
import KYCUpload from './functions/kyc_upload.js';
import $ from 'jquery';
import axios from 'axios';
import qs from 'qs';


export default class Account extends Component {

  render() {

    var email = window.email;
    var username = window.username;
    var last_login = window.last_login;
    var date_joined = window.date_joined;
    var kyc = window.kyc;

    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = 'X-CSRFToken';

    var data = this.props.data;

    var changepassword = function() {

      var password1 = $('#passWord1').val();
      var password2 = $("#passWord2").val();
      if (password1 !== password2) {
        PopUp.prototype.show(data.pwNoMatch);
      } else if (password1.length < 8) {
        PopUp.prototype.show(data.pwLessThan8);
      } else {
        axios.post('/api/loginchangepassword', qs.stringify({
          "password": password1,
        })).then(function (response) {
          if (response.data.status === 'saved'){
            PopUp.prototype.show(data.pwReset);
          } else {
            PopUp.prototype.show();
          }
        }).catch(function (error) {
            PopUp.prototype.show(data.failed + ":\n" + error.response.data.message);
        });
      }
      $('#passWord1').val("");
      $("#passWord2").val("");
    }

    var show_changePassword = function(){
    var accordion = $(".changePassword");
    var panel = accordion.next();
    if (panel.css("maxHeight") !== "0px"){
        panel.css("maxHeight", "0px");
    } else {
        panel.css("maxHeight", panel.prop('scrollHeight') + "0px");
    }
    }

    return (
            <div>

            <div class="row">
              <div class="col-lg-12 col-md-12">
                <div class="card-box task-detail">
                  <div class="media m-b-20 m-t-0">
                    <div class="media-body">
                        <h4 class="media-heading m-b-0"> {data.email}: {email} </h4>
                        <h4 class="media-heading m-b-0"> {data.username}: {username} </h4>
                    </div>
                    <ul class="list-inline task-dates m-b-0 m-t-20">
                        <li>
                            <h5 class="font-600 m-b-5">{data.datejoined}</h5>
                            <p> { date_joined }</p>
                            <p> {data.koreaTimezone} </p>
                        </li>
                        <li>
                            <h5 class="font-600 m-b-5">{data.lastlogin}</h5>
                            <p> { last_login }</p>
                            <p> {data.koreaTimezone} </p>
                        </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12 col-md-12">
                  <div class="card-box task-detail">
                      <div class="media m-b-20 m-t-0">
                          <div class="media-body">
                              <h4 class="media-heading m-b-0"> KYC</h4>
                              <h4 class="media-heading m-b-0"> KYC {data.status}: {data.level} {kyc} </h4>
                          </div>
                          <div class="m-t-10"></div>
                          <p>KYC {data.level} 1: {data.unableWithdraw}</p>
                          <p>KYC {data.level} 2: {data.limitedWithdraw}</p>
                          <p>KYC {data.level} 3: {data.higherWithdrawLimit}</p>
                      </div>
                  </div>
              </div>
            </div>

          <KYCUpload />

          <div class="row">
            <div class="col-lg-12">
              <button class="changePassword accordion_green btn-block text-left active" onClick={show_changePassword}>{data.changepassword}</button>
              <div class="accordion_panel">
                <div class="m-t-20"></div>
                <div class="form-group">
                    <label for="pass1">{data.newpassword}*</label>
                    <input id="passWord1" type="password" name="inputPassword" pattern=".{8,}" placeholder="Password" class="form-control" data-parsley-id="8" required />
                </div>
                <div class="form-group">
                    <label for="passWord2">{data.confirmpassword}*</label>
                    <input data-parsley-equalto="#pass1" name="inputConfirmPassword" pattern=".{8,}" type="password" placeholder="Password" class="form-control" id="passWord2" data-parsley-id="10" required />
                </div>
                <button type="submit" onClick={changepassword} class="btn btn-green w-md waves-effect waves-light">
                Save
                </button>
                <div class="m-b-20"></div>
              </div>
            </div>
          </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/account.js